import { BaseMutations } from '@/store/base-mutations';
import PurchaseOrdersState from './state';
import { PurchaseOrders, PurchaseOrdersFilters } from '../types';

export default class PurchaseOrdersMutations extends BaseMutations<PurchaseOrdersState> {
  SET_PURCHASE_ORDERS(purchase_orders: PurchaseOrders.PurchaseOrder[]) {
    this.state.purchase_orders = purchase_orders;
  }

  SET_PURCHASE_ORDER(purchase_order: PurchaseOrders.PurchaseOrder) {
    this.state.purchase_order = purchase_order;
  }

  SET_PURCHASE_ORDER_STATUS(status: string | null) {
    this.state.purchase_order!.status = status;
  }

  SET_STATUSES(statuses: PurchaseOrders.Status[] | string[]) {
    this.state.statuses = statuses;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof PurchaseOrdersFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  SET_CONTRACTORS_OR_BRANDS(contractors_or_brands: string[]) {
    this.state.contractors_or_brands = contractors_or_brands;
  }

  TOGGLE_LOADING(toggle: boolean) {
    this.state.loading = toggle;
  }
}
